import type { PlaylistItemVersionParam } from './types/playlist';

export function getPlaylistItemVersionIds(versionId: PlaylistItemVersionParam) {
  const selectedVersions =
    versionId && versionId !== 'latest' ? versionId.split(',') : undefined;
  return selectedVersions;
}
